import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
import { Case, User, Category, Tag } from "../../api/classes";
import CaseListItem from "../../pages/cases/caseListItem";
import { List, TextField, IconButton, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CategorySelect from "../categorySelect";
import FolderSelect from "../folderSelect";
import * as constants from "../../api/constants";
import FilterView from "../filter";
import { DubitoSvc } from "src/api";
import UserSelect from "../userSelect";

interface Props {
  open: boolean;
  cases: Case[];
  onClose: () => void;
  onCreate: (case_id: number) => void;
  users: User[];
  categories: Category[];
  tags: Tag[];
  fetchCases: () => void;
  fetchUsers: () => void;
  fetchCategories: () => void;
  fetchTags: () => void;
}

class CreateCaseDialog extends React.Component<Props> {
  state = {
    open: this.props.open,
    scroll: "paper",
    title: "",
    category: -1,
    folder: constants.FOLDER_NEWS_FEED,
    tags: [],
    creating: false,
    assignedUser: undefined,
    error: ""
  };
  componentWillReceiveProps(next: Props) {
    if (!this.props.open && next.open) {
      this.setState({ open: next.open });
    }
    //this.handleAutoAssign();
  }
  componentWillMount() {
    if (!this.props.cases) {
      this.props.fetchCases();
    }
    if (!this.props.users) {
      this.props.fetchUsers();
    }
    if (!this.props.categories) {
      this.props.fetchCategories();
    }
    if (!this.props.tags) {
      this.props.fetchTags();
    }
    // this.handleAutoAssign();
  }
  /* handleAutoAssign() {
    if (!this.state.assignedUser && this.props.users && this.props.cases) {
      const sorted = this.props.cases.sort((a, b) => b.id - a.id);
      const latestId = sorted.length > 0 ? sorted[0].id : 0;
      const nextId = latestId + 1;
      //TODO make this not harcoded
      const autoAssignUsers = [31, 29, 40, 47, 48];
      const aUserID = autoAssignUsers[nextId % autoAssignUsers.length];
      this.setState({ assignedUser: aUserID });
    }
  }*/
  handleCreate = () => {
    if (this.state.title.length === 0) {
      this.setState({ error: "Title is required" });
      return;
    }
    if (this.state.category === -1) {
      this.setState({ error: "Please select a category" });

      return;
    }
    this.setState({ creating: true });
    const tags = this.state.tags.map(e => e.value);
    DubitoSvc.createCase({
      title: this.state.title,
      category_id: this.state.category,
      folder: this.state.folder,
      tags: tags,
      assigned_user_id: this.state.assignedUser
    }).then(res => {
      this.setState({ creating: false });
      this.props.fetchCases();
      this.props.onCreate(res.id);
    });
  };
  handleClose = () => {
    if (this.state.creating) {
      return;
    }
    this.setState({ open: false, query: "" });
    this.props.onClose();
  };

  render() {
    const tags =
      this.props.tags &&
      this.props.tags.map(c => ({
        label: c.title,
        value: c.id
      }));
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={"paper"}
          aria-labelledby="scroll-dialog-title"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: { height: "100%" }
          }}
          style={{ height: "100%" }}
        >
          <DialogTitle id="scroll-dialog-title">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ flex: 1 }}>Create a new Case</span>
            </div>
          </DialogTitle>
          <DialogContent>
            {this.state.error.length > 0 && (
              <div style={{ color: "red", marginBottom: 16 }}>
                {this.state.error}
              </div>
            )}
            <TextField
              placeholder="Case Title"
              autoFocus
              onChange={e => this.setState({ title: e.target.value })}
              style={{ width: "100%" }}
              fullWidth
            />

            <CategorySelect
              style={{ marginTop: 24 }}
              id={this.state.category === -1 ? "-" : this.state.category}
              onSelect={id => this.setState({ category: id })}
            />
            <Typography variant="caption" style={{ marginTop: 8 }}>
              Folder
            </Typography>

            <FolderSelect
              value={this.state.folder}
              onSelect={id => this.setState({ folder: id })}
            />
            <Typography variant="caption" style={{ marginTop: 8 }}>
              Assign to user
            </Typography>
            <UserSelect
              id={this.state.assignedUser}
              onSelect={id => this.setState({ assignedUser: id })}
            />
            <div style={{ marginTop: 8 }} />
            <FilterView
              theme
              values={this.state.tags}
              suggestions={tags}
              title="Tags"
              placeholder="Afrin, Diyanet"
              onChange={(values: any[]) => {
                //console.log(values);
                this.setState({ tags: values });
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              disabled={this.state.creating}
              onClick={this.handleClose}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              disabled={this.state.creating}
              onClick={this.handleCreate}
              color="primary"
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: Props) => ({
    cases: state.cases.list,
    users: state.cases.users,
    categories: state.cases.categories,
    tags: state.cases.tags
  }),
  dispatch => ({
    fetchCases: (): any => dispatch(actions.fetchCases()),
    fetchUsers: (): any => dispatch(actions.fetchUsers()),
    fetchCategories: (): any => dispatch(actions.fetchCategories()),
    fetchTags: (): any => dispatch(actions.fetchTags())
  })
)(CreateCaseDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/createCase.tsx